import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

const StyledTable = styled.table`
  text-transform: uppercase;
  width: auto;

  ${props => props.width && css`
    width: ${props.width};
  `}

  ${props => props.maxWidth && css`
    max-width: ${props.maxWidth};
  `}

  ${props => props.minWidth && css`
    min-width: ${props.minWidth};
  `}
`

const Table = ({ children, id, width, maxWidth, minWidth }) => {
  return (
    <StyledTable
      id={id}
      width={width}
      maxWidth={maxWidth}
      minWidth={minWidth}
    >
      {children}
    </StyledTable>
  )
}

Table.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  width: PropTypes.string,
  maxWidth: PropTypes.string,
  minWidth: PropTypes.string,
}

export default Table
